/*
 * Copyright (c) 2023 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
 /**
  * Yesan platform configuration
  * @class YSConfig
  * @author Vincent BONESTEVE
  */
export default class YSConfig {
  /**
   * Yesan coming soon
   * @static
   */
  static YS_COMING_SOON = false;
  /**
   * Yesan color
   * @static
   */
  static YS_COLOR = "#33cb99";
  /**
   * Yesan App Store URL
   * @static
   */
  static APPSTORE_URL = "https://apps.apple.com/app/yesan-personal-finance/id6476198291";
  /**
   * Yesan Google Play URL
   * @static
   */
  static GOOGLEPLAY_URL = "https://play.google.com/store/apps/details?id=app.yesan.pf";
  /**
   * Yesan app site URL
   * @static
   */
  static APPSITE_URL = "https://yesan.app";
  /**
   * Yesan Kakeibo App Store URL
   * @static
   */
  static YK_APPSTORE_URL = "https://apps.apple.com/app/yesan-kakeibo/id6563149971";
  /**
   * Yesan Kakeibo Google Play URL
   * @static
   */
  static YK_GOOGLEPLAY_URL = "https://play.google.com/store/apps/details?id=app.yesan.kakeibo";
  /**
   * Yesan Genea App Store URL
   * @static
   */
  static YG_APPSTORE_URL = "https://apps.apple.com/app/yesan-genea/id6745765479";
  /**
   * Yesan Genea Google Play URL
   * @static
   */
  static YG_GOOGLEPLAY_URL = "https://play.google.com/store/apps/details?id=app.yesan.genea";
  /**
   * Yesan blog URL
   * @static
   */
  static BLOG_URL = "https://yesan.finance";
  /**
   * Yesan support URL
   * @static
   */
  static SUPPORT_URL = "https://support.yesan.info";
  /**
   * Yesan privacy URL
   * @static
   */
  static PRIVACY_URL = "https://support.yesan.info/privacy";
  /**
   * Yesan terms URL
   * @static
   */
  static TERMS_URL = "https://support.yesan.info/terms";
  /**
   * Yesan Instagram URL
   * @static
   */
  static INSTAGRAM_URL = "https://www.instagram.com/yesanpf";
  /**
   * Yesan Twitter URL
   * @static
   */
  static TWITTER_URL = "https://twitter.com/YesanSas";
  /**
   * Yesan LinkedIn URL
   * @static
   */
  static LINKEDIN_URL = "https://www.linkedin.com/company/yesan-sas";
  /**
   * Yesan Facebook URL
   * @static
   */
  static FACEBOOK_URL = "https://www.facebook.com/people/Yesan-SAS/61557020578568/";
  /**
   * Yesan contact URL
   * @static
   */
  static CONTACTFORM_URL = "https://api.yesan.app/crm";
  /**
   * Yesan map URL
   * @static
   */
  static MAP_URL="https://maps.app.goo.gl/azevd1p9fKn6p6po6";
  /**
   * Yesan WLC marketplace URL
   * @static
   */
  static WLC_MARKETPLACE_URL = "https://marketplace.atlassian.com/1236252"
  /**
   * Yesan YFP marketplace URL
   * @static
   */
  static YFP_MARKETPLACE_URL = "https://marketplace.atlassian.com/apps/327388605"
  /**
   * Google Analytics measurement ID
   * @static
   */
  static GA_MEASUREMENT_ID = "G-6LC2B1N6SR";


}
